/** Calendar-day arithmetic on local dates. Results are at local midnight. */

/** Number of days in `date`'s month (28–31). */
export const daysInMonth = (date: Date): number =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

/** `date` moved by `days` calendar days (negative goes back). */
export const addDays = (date: Date, days: number): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);

/** `date` moved by `months` calendar months, keeping the day of the month or, when the target month is
 *  shorter, its last day (31/01 + 1 = 28/02) — like BigQuery's DATE_ADD. */
export const addMonths = (date: Date, months: number): Date => {
  const targetMonthStart = new Date(date.getFullYear(), date.getMonth() + months, 1);
  const day = Math.min(date.getDate(), daysInMonth(targetMonthStart));
  return new Date(targetMonthStart.getFullYear(), targetMonthStart.getMonth(), day);
};
